export default "__VITE_ASSET__BSwetDjV__"